import parseTimestamp from "../../../lib/parseTimestamp";
const formatDate = (dateString) => {
  const formattedDate = parseTimestamp(dateString);
  // date.getMonth() result is 0-indexed, i.e. 0 is January;
  // to display the month number correctly, we need a `+1`
  return formattedDate.getMonth() + 1 + "/" + formattedDate.getFullYear();
};

export default formatDate;
